/**
 * Keeps the free-shipping progress bar(s) in sync with the cart.
 *
 * The bar's HTML/CSS (and its initial state) is rendered server-side by
 * snippets/free-shipping-bar.liquid, so there is no flash of incorrect
 * content on page load. This script's only job is to refresh the bar
 * whenever the cart changes (add to cart, quantity change, remove item),
 * by re-fetching the section that contains it and swapping in the fresh,
 * server-rendered (and correctly money-formatted) markup — the same
 * pattern Dawn's own cart.js already uses elsewhere.
 *
 * Covers both possible cart UI setups so the bar keeps working even if
 * the store's "Cart type" setting (Settings > Cart) is ever changed:
 *  - cart_type "notification" (the current setting): the small popup
 *    that appears near the cart icon — bar lives in a dedicated
 *    "free-shipping-bar" section.
 *  - cart_type "drawer": the full slide-out cart — bar lives in the
 *    "cart-drawer" section.
 */
(function () {
  function refreshBar(sectionId, elementId) {
    var current = document.getElementById(elementId);
    if (!current) return; // this bar isn't present on the current page

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';

    fetch(cartUrl + '?section_id=' + sectionId)
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var updated = html.getElementById(elementId);
        var target = document.getElementById(elementId);
        if (updated && target) {
          target.replaceWith(updated);
        } else if (!updated && target) {
          // Cart became empty (or bar condition no longer met) — remove it.
          target.remove();
        }
      })
      .catch(function (error) {
        console.error('[free-shipping-bar]', error);
      });
  }

  function refreshAllBars() {
    refreshBar('free-shipping-bar', 'CartNotification-FreeShippingBar');
    refreshBar('cart-drawer', 'CartDrawer-FreeShippingBar');
    refreshBar('main-cart-items', 'Cart-FreeShippingBar');
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshAllBars);
    }
  });
})();
